import { jsx, css } from '@emotion/react';
import styled from '@emotion/styled';

import { pageUrl } from '../helpers/page_url';
import { connectLocation } from '../location/LocationConnectors';

const BannerStyles = styled.div`
  .banner {
    text-align: center;
    height: 71px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 7px;
    background-color: ${props => (props.mode === 'dark' ? 'black' : 'white')};
  }

  .icon {
    color: ${props => (props.mode === 'dark' ? 'white' : 'black')};
    margin: 14px;

    &:hover {
      color: #d40f7d;
    }
  }

  .captionText {
    color: ${props => (props.mode === 'dark' ? 'white' : 'black')};
  }

  .facebook-icon {
    display: ${props => (props.facebook ? '' : 'none')};
  }

  .twitter-icon {
    display: ${props => (props.twitter ? '' : 'none')};
  }

  .linkedin-icon {
    display: ${props => (props.linkedin ? '' : 'none')};
  }

  .pinterest-icon {
    display: ${props => (props.pinterest ? '' : 'none')};
  }
`;

const SocialMediaShareBanner = connectLocation(props => {
  const mode = props.mode || 'dark';
  const shareUrl = pageUrl(props);
  return (
    <BannerStyles
      mode={mode}
      facebook={props.facebook}
      twitter={props.twitter}
      linkedin={props.linkedin}
      pinterest={props.pinterest}
    >
      <div className="banner">
        <span className="captionText">{props.text}: </span>
        <a
          className="facebook-icon"
          target="_blank"
          href={`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}&quote=${props.shareMessage}`}
          rel="noreferrer"
        >
          <i className="fa fa-facebook-square fa-2x icon" />
        </a>
        <a
          className="twitter-icon"
          target="_blank"
          href={`https://twitter.com/intent/tweet?url=${shareUrl}&text=${props.shareMessage}`}
          rel="noreferrer"
        >
          <i className="fa fa-twitter fa-2x icon" />
        </a>
        <a
          className="linkedin-icon"
          target="_blank"
          href={`https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`}
          rel="noreferrer"
        >
          <i className="fa fa-linkedin-square fa-2x icon" />
        </a>
        <a
          className="pinterest-icon"
          target="_blank"
          href={`http://pinterest.com/pin/create/button/?url=${shareUrl}`}
          rel="noreferrer"
        >
          <i className="fa fa-pinterest fa-2x icon" />
        </a>
      </div>
    </BannerStyles>
  );
});

export default SocialMediaShareBanner;
